import {SurveySlug} from '../../../utils/types';

export const AGE_GROUPS = [
    'Infanti (0-3 anni)',
    'Piccoli (4-6)',
    'Bambini (6-10)',
    'Pre-adolescenti (11-13)',
    'Adolescenti (14-18)',
    'Giovani (19-34)',
    'Adulti (35-64)',
    'Anziani (≥65)',
];

export const buildFruitoriSlug = (
    finaleSurveyId: number,
    aggiornamentoSurveyId: number,
    inizialeSurveyId: number,
): SurveySlug => ({
    numerator: {survey_id: finaleSurveyId, question: 'question6'},
    denominator: {survey_id: inizialeSurveyId, question: 'question6'},
    operation: 'sum',
    key: 'fruitori',
    roman: '',
    title: 'Tasso di raggiungimento dei fruitori attesi a confronto con la media',
    tooltip:
        "Il grafico mostra la percentuale di fruitori effettivamente raggiunti rispetto al numero di fruitori attesi da tutte le iniziative del progetto, a confronto con la media dello stesso valore per tutti i progetti. La percentuale media è ottenuta sommando le percentuali di fruitori raggiunti rispetto ai fruitori attesi e dividendo il risultato per il numero totale di progetti.",
    aggregateChildren: true,
    perUoaLatest: true,
    fallbacks: [{
        operation: 'sum',
        numerator: {survey_id: aggiornamentoSurveyId, question: 'question6'},
        denominator: {survey_id: inizialeSurveyId, question: 'question6'},
    }],
});

export const buildTargetSlugs = (
    aggiornamentoSurveyId: number,
    inizialeSurveyId: number,
    ageGroupQuestion: string,
): SurveySlug[] =>
    AGE_GROUPS.map((label, i): SurveySlug => ({
        numerator: {
            survey_id: aggiornamentoSurveyId,
            question: `${ageGroupQuestion}_row_${i + 1}_column_1`,
        },
        denominator: {
            survey_id: aggiornamentoSurveyId,
            question: `${ageGroupQuestion}_total_column_1`,
        },
        operation: 'sum',
        key: `target_age_row-${i + 1}`,
        roman: '',
        title: label,
        tooltip: '',
        aggregateChildren: true,
        perUoaLatest: true,
        positiveRatio: true,
        fallbacks: [{
            operation: 'match',
            numerator: {survey_id: inizialeSurveyId, question: 'question9', value: `Item ${i + 1}`},
        }],
    }));

export const buildCollaborazioniSlugs = (inizialeSurveyId: number): SurveySlug[] => [
    {
        numerator: {survey_id: inizialeSurveyId, question: 'question11', value: 'Item 1'},
        operation: 'match',
        key: 'question11_item-1',
        roman: '',
        title: 'Iniziative collaborative previste a confronto con la media',
        tooltip:
            'Il grafico mostra la percentuale di iniziative previste nel vostro progetto che sono frutto di collaborazioni, a confronto con la media dello stesso valore calcolata per tutti i progetti. La percentuale media di iniziative frutto di collaborazioni si ottiene calcolando, per ciascun progetto, la percentuale di iniziative con collaborazioni. Queste percentuali vengono poi mediate su tutti i progetti.',
        aggregateChildren: true,
        perUoaLatest: true,
    },
];
